<template>
    <v-menu offset-y>
        <v-btn slot="activator" dark  flat large>
          <v-icon>account_circle</v-icon>
          <span> {{ this.user }}</span>
        </v-btn>
        <v-list>
            <v-list-tile v-for="item in items" :key="item.title" @click="goToAction(item.link)">
                <v-list-tile-content>{{ item.title }}</v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-menu>
</template>

<script>
  export default {
    data() {
        return {
            name: 'account-controls',
            items: [
                { title: 'My Account', link: "Account"},
                { title: 'Logout' , link: "Logout"}
            ],
            user: ''
        }
    },
    methods: {
        goToAction(action){
            if(action == 'Logout') {
                this.$store.commit('removeUserData');
                window.location.href = '#/users/login';
            }

            if(action == 'Account') {
                window.location.href = '#/account';
            }
        },

        getUserData() {
            if(this.$store.state.userdata != null)
            {
                var title = 
                typeof this.$store.state.userdata.title  != "undefined" ? this.$store.state.userdata.title : '';
                
                var user = '';
                if(this.$store.state.usertype == 'student')
                {
                    user = this.$store.state.userdata.lastName + ', ' + this.$store.state.userdata.firstName;
                } else {
                    user = title + ' '
                    + this.$store.state.userdata.firstName + ' '
                    + this.$store.state.userdata.lastName;
                }
                

                return user;
            }

            return '';
            
        }
    },
    mounted() {
        this.user = this.getUserData();
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/AccountControls.vue